import { css } from "@emotion/react";
import React from "react";
import { Link } from "react-router";
import { CSS_COLORS } from "../../../styles/styles-css-variables";
import { firstFocusableChildrenOf } from "./firstFocusableChildrenOf";

const MAIN_CONTENT_ID = "main-content";

export const A18y_SkipToContent: React.FC = () => {
  function onClick() {
    const mainContent = document.getElementById(MAIN_CONTENT_ID);

    const el = mainContent?.children[0];

    if (el) {
      el.scrollIntoView({
        behavior: "smooth",
      });

      const selectable = firstFocusableChildrenOf(el as HTMLElement);

      selectable?.focus();
    }
  }

  return (
    <Link
      tabIndex={0}
      to={{
        hash: `#${MAIN_CONTENT_ID}`,
      }}
      onClick={onClick}
      css={css`
        position: absolute;
        left: -100px;
        top: -100px;
        z-index: 1000;

        &:focus {
          display: block;
          position: absolute;
          top: 0;
          left: 0;
          z-index: 1000;

          padding: 10px 6px;

          background-color: white;
          color: ${CSS_COLORS.Green};
        }
      `}
    >
      Skip to main content
    </Link>
  );
};

export const A18y_MainContent: React.FC<React.PropsWithChildren> = ({ children }) => {
  return (
    <main
      id={MAIN_CONTENT_ID}
      tabIndex={-1}
      css={css`
        display: contents;
      `}
    >
      {children}
    </main>
  );
};
